(() => {
  const initialize = () => {
    const source = document.getElementById('ContactReferral');
    const other = document.getElementById('ContactReferralOther');
    const details = document.getElementById('ContactReferralDetails');
    if (!source || !other || !details || source.dataset.otherSourceInitialized) return;
    source.dataset.otherSourceInitialized = 'true';
    const update = () => {
      const show = source.value === 'Other';
      other.hidden = !show;
      details.disabled = !show;
    };
    source.addEventListener('change', update);
    source.form?.addEventListener('reset', () => setTimeout(update, 0));
    window.addEventListener('pageshow', update);
    update();
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
